// extracted by mini-css-extract-plugin
export default {"modalBodyContainer":"G08a1cd","modalHeaderTitle":"Gd93495"};